import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from "@angular/core";
import "@enersis/gp-components/gp-tag";

@Component({
  selector: "tpm-tag",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: "tag.component.html",
  styleUrls: ["tag.component.scss"]
})
export class TagComponent {
  @Input() adapt: boolean = true;
  @Input() textColor: string | undefined;
  @Input() backgroundColor: string | undefined;
}
